import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "content", "input"]
  static values = {
    selectInput: { type: Boolean, default: false },
    activeClass: String,
    inactiveClass: String
  }

  toggle(event) {
    const index = this.sectionTargets.indexOf(event.currentTarget)
    this.contentTargets.forEach((el, i) => {
      if (i === index) {
        el.classList.remove("hidden")
        if (this.selectInputValue && this.hasInputTarget) {
          this.inputTargets[i].checked = true
          this.inputTargets[i].dispatchEvent(new Event("change"))
        }
        el.parentNode.classList.remove(...this.inactiveClassValue.split(" "))
        el.parentNode.classList.add(...this.activeClassValue.split(" "))
      } else {
        el.classList.add("hidden")
        el.parentNode.classList.add(...this.inactiveClassValue.split(" "))
        el.parentNode.classList.remove(...this.activeClassValue.split(" "))
      }
    })
  }
}
